<style lang="less">
  .signUp,.signUpM{
    width: 275px;
    margin: auto;
    text-align: left;
    padding-top: 4px;
    .formMessage{
      // margin-top: 9px;
      .inputLi{
        height: 37px;
        line-height: 37px;
        border-bottom: 1px solid #D5D6D6;
        margin-bottom: 24px;
        position: relative;
        input{
          border: 0;
          outline: none;
          font-size: 17px;
          width: 152px;
        }
      }
      .phoneNum{
        position: relative;
        .areaInput{
          width: 90px;color:#11C879;
          cursor: pointer;
        }
        .optionList{
          position: absolute;
          overflow-y: auto;
          width: 200px;height:300px;
          background: #fff;
          border: 1px solid #D5D6D6;
          border-top:none;
          font-size: 14px;
          z-index: 999999999;
          li{
            line-height:2;
            padding-right: 6px;
          }
        }
        .arrowDown{
          position: absolute;
          width:0;
          height:0;
          border-right:4.5px solid transparent;
          border-left:4.5px solid transparent;
          border-top:6px solid #A0A2AA;
          margin-top: 15px;
          margin-left: -25px;
        }
        .number{
          width: 185px;font-size: 17px;
        }
      }
      .picCode{
        img{
          position: absolute;
          width: 103px;
          height: 35px;
          cursor: pointer;
          right: 0;bottom: 2px;
        }
      }
      .msgCode{
        .sendCode{
          width: 103px;height:33px;
          line-height: 33px;
          background: #13C477;
          color:#fff;
          border-radius: 4px;
          text-align:center;
          position: absolute;
          right: 0;bottom: 2px;
          cursor: pointer;
        }
        .sendMsgInfo{
          background: #E0E0E0;
          color: #fff;
        }
      }
      .isRegister{
        input{
          width: 100%;
          padding-right: 44px;
        }
        img{
          position: absolute;
          width: 18px;
          color:#9B9B9B;
          top: 8px;
          right: 8px;
        }
      }

    }
    .errorMsg{
      position: absolute;
      font-size: 14px;
      color:#FF5741;
      left: 0;top: 30px;
    }
    .userAgreement{
      font-size: 14px;
      position: relative;
      margin-top: 36px;
      .userAgreementCheck{
        font-size: 13px;
        color:#11C577;
        cursor: pointer;
        margin-right: 5px;
      }
      .is-link{
        color:#11C577;
      }
    }
  }
  .signUpM{
    width: 550px;
    padding-top: 8px;
    .formMessage{
      // margin-top: 18px;
      .inputLi{
        height: 74px;
        line-height: 74px;
        margin-bottom: 48px;
        input{
          font-size: 34px;
          width: 304px;
        }
      }
      .phoneNum{
        .areaInput{
          width: 180px;
        }
        .optionList{
          width: 400px;height:600px;
          font-size: 28px;
          li{
            padding-right: 12px;
          }
        }
        .arrowDown{
          border-right:9px solid transparent;
          border-left:9px solid transparent;
          border-top:12px solid #A0A2AA;
          margin-top: 30px;
          margin-left: -50px;
        }
        .number{
          width: 370px;font-size: 34px;
        }
      }
      .picCode{
        img{
          width: 206px;
          height: 70px;
          bottom: 4px;
        }
      }
      .msgCode{
        .sendCode{
          width: 206px;height:66px;
          line-height: 66px;
          border-radius: 8px;
          bottom: 4px;
        }
      }
      .isRegister{
        input{
          width: 100%;
          padding-right: 88px;
        }
        img{
          width: 36px;
          margin-top: 7px;
          right: 16px;
        }
      }
    }
    .errorMsg{
      font-size: 28px;
      top: 58px;
    }
    .userAgreement{
      font-size: 28px;
      margin-top: 72px;
      .userAgreementCheck{
        font-size: 26px;
        margin-right: 10px;
      }
    }
  }
</style>
<template>
  <div :class="isMobile?'signUpM':'signUp'" >
    <ul class="formMessage eeo-ul">
      <li class="inputLi phoneNum">
        <input type="text" readonly="readonly"
          @click.stop="showOptionList"
          v-model="form.selectAreaShow" class="areaInput" />
        <span class="arrowDown"></span>
        <ul class="eeo-ul optionList" v-show="optionList" ref="optionList">
          <li v-for="(item,index) in phoneAreaNumList"
            :key="item.label"
            @click="selectAreaCode(item)"
            :style="{background:(item.show==form.selectAreaShow)?'#ddd':''}">
            {{item.label}}
          </li>
        </ul>
        <input class="number"
          type="text"
          v-model="form.phoneNumber"
          @blur="phoneNumbervalidate(form.phoneNumber)"
          :placeholder="$t('publesson.placeholder.phoneNumber')" />
        <span
          v-if="rules.phoneNumber"
          class="errorMsg">
          {{errorMsg.phoneNumber}}
        </span>
      </li>
      <li v-if="!registerConfig.isRegister" class="inputLi">
        <input
          type="text"
          v-model="form.nickName"
          autocomplete="off"
          :placeholder="$t('publesson.placeholder.nickName')"
          @blur="namevalidate(form.nickName)"
          style="width: 100%"/>
        <span v-if="rules.nickName" class="errorMsg">
          {{errorMsg.nickName}}
        </span>
      </li>
      <li class="inputLi picCode">
        <input
          type="text"
          v-model="form.picCode"
          :placeholder="$t('publesson.placeholder.verCode')"
          @blur="picCodevalidate(form.picCode)"/>
        <img :src="form.codeSrc" @click="changePicCode">
        <span v-if="rules.picCode" class="errorMsg">
          {{errorMsg.picCode}}
        </span>
      </li>
      <li class="inputLi msgCode">
        <input
          type="text"
          v-model="form.msgCode"
          :placeholder="$t('publesson.placeholder.msmCode')"
          @blur="msgCodevalidate(form.msgCode)"
          autocomplete="off"
          style="-webkit-appearance: none;
          -webkit-box-shadow: 0 0 0 1000px white inset !important;
          background-color:rgb(255,255,255);
          outline: none;border: 0;"/>
        <span class="sendCode" @click="sendMsgCode"
          :class="{sendMsgInfo:(sendMsgInfo.isSending)}">
          {{sendMsgInfo.btnTxt}}
        </span>
        <span v-if="rules.msgCode" class="errorMsg">
          {{errorMsg.msgCode}}
        </span>
      </li>
      <!-- 未注册账号输入密码 -->
      <li v-if="!registerConfig.isRegister" class="inputLi isRegister">
        <input
          :type="registerConfig.inputType"
          v-model="form.password"
          autocomplete="off"
          :placeholder="$t('publesson.placeholder.password')"
          @blur="pwdCodevalidate(form.password)"/>
        <img :src="registerConfig.pwdIcon"
          @mousedown="isShowPwd(true)"
          @touchstart="isShowPwd(true)"
          @mouseup="isShowPwd(false)"
          @touchend="isShowPwd(false)"
          @mouseleave="isShowPwd(false)"/>
        <span v-if="rules.password" class="errorMsg">
          {{errorMsg.password}}
        </span>
      </li>
    </ul>
    <div class="userAgreement">
      <span class="userAgreementCheck"
        @click="isAgreeUserAgreement"
        :class="[form.agreeUserAgreement?'el-icon-checkbox':'el-icon-checkbox_noselect']"></span>
      <span v-html="$t('publesson.readUserAgm')"></span>
    </div>
    <button class="submitBtn" @click="submit" :style="{background:(rules.userAgreement)?'#98ddbc':''}">
      {{$t('publesson.apply')}}
    </button>
  </div>
</template>

<script>
  import restful_publesson  from '@/api/publesson/restful_publesson.js';
  export default {
    props:['config'],
    filters:{
    },
    components:{
    },
    data(){
      return {
        isMobile: window.browserVersion.mobile,
        clientName:'',
        phoneAreaNumList:[],
        lang:'',
        form:{
          selectAreaShow:'+86',
          selectArea:'0086',
          phoneNumber:'',
          nickName: '',
          picCode:'',
          msgCode:'',
          password:'',
          codeSrc: '//'+window.EEOENV.hosts.dynamic+'/import/captcha/captcha.php',
          agreeUserAgreement:true
        },
        rules:{
          phoneNumber:false,
          nickName: false,
          picCode:false,
          msgCode:false,
          password:false
        },
        registerConfig:{
          isRegister:true,
          pwdIcon:'/s/publesson/images/icon_passwordview_hide.png',
          inputType:'password'
        },
        errorMsg:{
          phoneNumber:this.$t('publesson.errorMsg.enterPhoneNumber'),
          nickName: this.$t('publesson.errorMsg.enterName'),
          picCode:this.$t('publesson.errorMsg.enterVerCode'),
          msgCode:this.$t('publesson.errorMsg.enterVerCode'),
          password:this.$t('publesson.placeholder.password'),
        },
        sendMsgInfo:{
          isSending:false,
          countDown:60,
          btnTxt:this.$t('publesson.form.sendMsg'),
        },
        disabled:false,
        optionList:false,
        timer:''
      }
    },
    computed:{
    },
    methods:{
      closeOptionList(){
        this.optionList = false;
      },
      showOptionList(){
        this.optionList = !this.optionList;
        this.$nextTick(()=>{
          if(this.form.selectAreaShow=='+86'){
            this.$refs.optionList.scrollTop=this.$refs.optionList.scrollHeight;
          }
        })
      },
      selectAreaCode(item){
        this.form.selectAreaShow = item.show;
        this.form.selectArea = item.value;
        if(!(this.form.phoneNumber=='')){
          this.phoneNumbervalidate(this.form.phoneNumber)
        }
      },
      sendMsgCode(){
        if(!this.form.phoneNumber){
          this.errorMsg.phoneNumber=this.$t('publesson.errorMsg.enterPhoneNumber');
          this.rules.phoneNumber=true
        }
        if(!this.form.picCode){
          this.errorMsg.picCode=this.$t('publesson.errorMsg.enterVerCode');
          this.rules.picCode=true
        }
        var visiable=this.sendMsgInfo.isSending||this.rules.phoneNumber||this.rules.picCode
        if(!visiable){
          this.rules.msgCode=false;
          var postData = {
            selectArea:this.form.selectArea,
            phoneNumber:this.form.phoneNumber,
            picCode:this.form.picCode
          }
          restful_publesson('sendCode',postData).then((res)=>{
            var resData = res.data;
            if(typeof resData=='number'){
              switch (resData) {
                case 104:
                  this.errorMsg.msgCode=this.$t('publesson.errorMsg.operateFail');
                  this.rules.msgCode=true;
                  break;
                case 108:
                  this.errorMsg.msgCode=this.$t('publesson.errorMsg.sendLimit');
                  this.rules.msgCode=true;
                  break;
                case 109:
                  this.errorMsg.msgCode=this.$t('publesson.errorMsg.sendfrequently');
                  this.rules.msgCode=true;
                  break;
                case 110:
                  this.errorMsg.msgCode=this.$t('publesson.errorMsg.sendFail');
                  this.rules.msgCode=true;
                  break;
                case 134:
                  this.errorMsg.phoneNumber=this.$t('publesson.errorMsg.phoneIllegal');
                  this.rules.phoneNumber=true;
                  break;
                case 346:
                  this.changePicCode();
                  this.errorMsg.picCode=this.$t('publesson.errorMsg.wrongVerCode');
                  this.rules.picCode=true;
                  break;
              }
            }else{
              if(resData){
                this.sendMsgInfo.isSending = true;
                this.sendMsgInfo.countDown = 60;
                this.timer = setInterval(()=>{
                  this.sendMsgInfo.countDown--;
                  this.sendMsgInfo.btnTxt = this.$t('publesson.form.reSend',{num:this.sendMsgInfo.countDown});
                  if(this.sendMsgInfo.countDown<1){
                    this.sendMsgInfo.btnTxt = this.$t('publesson.form.sendMsg');
                    clearInterval(this.timer);
                    this.sendMsgInfo.isSending = false;
                  }
                },1000)
              }
            }
          })
        }
      },
      checkForm(){
        for(var key in this.form){
          if(this.form[key]===''){
            this.rules[key]=true;
            if(this.registerConfig.isRegister){
              this.rules.nickName = false;
              this.rules.password = false;
            }
          }
        }
      },
      addStudent(postData){
        var postData={
          lessonId:   this.config.lessonId,
          selectArea: this.form.selectArea,
          phoneNumber:this.form.phoneNumber,
          msgCode:    this.form.msgCode,
        }
        this.form.nickName && (postData.nickName = this.form.nickName)
        clearInterval(this.timer);
        restful_publesson('addlessonStu',postData).then((res)=>{
          this.$root.pageLoading(false);
          var resData = res.data;
          if(typeof resData=='string'){
            alert(resData);
            this.changePicCode();
          }else{
            switch (resData) {
              case 1:
                this.$emit('signUp','signUpSuccess');
                break;
              case 111:
                this.errorMsg.msgCode=this.$t('publesson.errorMsg.wrongVerCode');
                this.rules.msgCode=true;
                break;
              case 128:
                window.meaasgeAlert(this.$t('publesson.tip.noAddStu'));
                break;
              case 129:
                window.meaasgeAlert(this.$t('publesson.tip.teacher'));
                break;
              case 157:
                this.$emit('signUp','lessonStuFull');
                break;
              case 166:
                this.$emit('signUp','signUpSuccess');
                break;
              case 212:
                this.$emit('routerTo','tipPage');
                break;
              case 304:
                window.meaasgeAlert(this.$t('publesson.tip.institutionDisabled'));
                break;
              case 329:
                window.meaasgeAlert(this.$t('publesson.tip.assistant'));
                break;
            }
          }
        });
      },
      submit(){
        if(this.form.agreeUserAgreement){
          this.checkForm();
          var verify = true;
          for(var key in this.rules){
            if(this.rules[key]){
              verify = false;
            }
          }
          if(verify){
            this.$root.pageLoading(true);
            if(!this.registerConfig.isRegister){
              var postData={
                selectArea: this.form.selectArea,
                phoneNumber: this.form.phoneNumber,
                nickName: this.form.nickName,
                msgCode: this.form.msgCode,
                password: this.form.password,
                isLogin: false
              }
              restful_publesson('userRegister',postData).then((res)=>{
                var resData = res.data;
                switch (resData) {
                  case 1:
                    this.addStudent();
                    break;
                  case 111:
                    this.errorMsg.msgCode=this.$t('publesson.errorMsg.wrongVerCode');
                    this.rules.msgCode=true;
                    this.$root.pageLoading(false)
                    break;
                }
              })
            }else{
              this.addStudent();
            }
          }
        }
      },
      isAgreeUserAgreement(){
        this.rules.userAgreement = this.form.agreeUserAgreement;
        this.form.agreeUserAgreement = !this.form.agreeUserAgreement;
      },
      getPhoneArea(){
        this.lang = this.$root.globalData.localeLangType
        window.requireJs(['/assets/data/js/phoneareanum.js'], data=>{
          data.map((v,i)=>{
            var list={
              show: '+' + v.num,
              value:'00'+v.num,
              label:'+' + v.num + '(' + v.name[this.lang === 'zh-CN' ? 'cn' : 'en'] + ')'
            }
            this.phoneAreaNumList.push(list)
          })
        })
      },
      phoneNumbervalidate(value){
        this.rules.phoneNumber=false;
        this.errorMsg.phoneNumber='';
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if(value===''){
          this.errorMsg.phoneNumber=this.$t('publesson.errorMsg.enterPhoneNumber');
          this.rules.phoneNumber=true;
          return false
        }else{
          if((this.form.selectArea==='0086')&&(value.length!=11)){
            this.errorMsg.phoneNumber=this.$t('publesson.errorMsg.enterTruePhoneNumber');
            this.rules.phoneNumber=true;
            return false
          }else if(parseInt(value)!=value){
            this.errorMsg.phoneNumber=this.$t('publesson.errorMsg.enterTruePhoneNumber');
            this.rules.phoneNumber=true;
            return false
          }else{
            var telephone = (this.form.selectArea=='0086')?
                            this.form.phoneNumber:
                            this.form.selectArea+'-'+this.form.phoneNumber;
            restful_publesson('check',{telephone:telephone}).then((res)=>{
              var resData = res.data;
              if(typeof resData=='number'){
                switch (resData) {
                  case 104:
                    this.errorMsg.phoneNumber=this.$t('publesson.errorMsg.operateFail');
                    this.rules.phoneNumber=true;
                    break;
                  case 134:
                    this.errorMsg.phoneNumber=this.$t('publesson.errorMsg.phoneIllegal');
                    this.rules.phoneNumber=true;
                    break;
                }
              }else{
                this.registerConfig.isRegister=resData;
              }
            })
          }
        }
      },
      namevalidate(value){
        this.rules.nickName = false;
        this.errorMsg.nickName = '';
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if (value === '') {
          this.errorMsg.nickName = this.$t('publesson.errorMsg.enterName');
          this.rules.nickName = true;
          return false
        } else {
          let valueLen = value.length;
          if (valueLen < 2 || valueLen > 24) {
            this.errorMsg.nickName = this.$t('publesson.errorMsg.enterNameRule');
            this.rules.nickName = true;
            return false
          }
        }
      },
      picCodevalidate(value){
        this.rules.picCode=false;
        this.errorMsg.picCode='';
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if(value===''){
          this.errorMsg.picCode=this.$t('publesson.errorMsg.enterVerCode');
          this.rules.picCode=true;
          return false
        }
      },
      msgCodevalidate(value){
        this.rules.msgCode=false;
        this.errorMsg.msgCode='';
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if(value===''){
          this.errorMsg.msgCode=this.$t('publesson.errorMsg.enterVerCode');
          this.rules.msgCode=true;
          return false
        }
      },
      pwdCodevalidate(value){
        this.errorMsg.password='';
        this.rules.password=false;
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if(value===''){
          this.errorMsg.password=this.$t('publesson.errorMsg.enter6To20Pwd');
          this.rules.password=true;
          return false
        }else{
          if(value.length<6||value.length>20){
            this.errorMsg.password=this.$t('publesson.errorMsg.enter6To20Pwd');
            this.rules.password=true;
            return false
          }
        }
      },
      isShowPwd(status){
        this.registerConfig.pwdIcon = status ?
        '/s/publesson/images/icon_passwordview_show.png' :
        '/s/publesson/images/icon_passwordview_hide.png';
        this.registerConfig.inputType = status?'text':'password';
      },
      changePicCode(){
        this.form.codeSrc='//'+window.EEOENV.hosts.dynamic+'/import/captcha/captcha.php?ts=' + new Date().valueOf();
      },
    },
    created(){
      this.getPhoneArea();
    },
    mounted(){
      this.clientName = this.$root.clientName;
    }
  }
</script>